const covid = '/covid';

export const authorization = {    
  credentials: 'include',
  headers: {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  },
  noTokenHeaders: {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'      
  }        
};

export const setHeadersToken = () =>{
  // return `Bearer ${GetToken()}`;
}

export const baseUrl = {
  apiExameCovid: 'https://apiexamecovid.drogal.com.br:7790/',    // 10.215.2.14
  localhostHTTPS:'https://localhost:44335/',
  api_10_215_2_14_8890:'http://10.215.2.14:8890/',
  filial36drogal:'http://filial36drogal.ddns.com.br:18890/',
  filial36drogal_https:'https://filial36drogal.ddns.com.br:7790/'
}

export const addresses = {  
  covidTest:{
    filial: `${covid}/filial`,
    cities: `${covid}/cidades`, 
    tipoExame: `${covid}/tipoExame`,
    consultaAgenda: `${covid}/consultaAgenda`,
    gravarAgenda: `${covid}/gravarAgenda`,
    enviarTokenPorSms: `${covid}/enviarTokenPorSms`,
    cancelarPreToken: `${covid}/cancelarPreToken`,
    consultaEstoque: `${covid}/consultaEstoque`,
    // whatssApp: 'https://wa.me/message/YYHNEMKCCQB5D1',
    whatssApp: 'https://wa.me/5508003470000',
    // telemedicina: 'https://cliente.drogal.com.br/telemedicina/',    
    enviarTokenCancelamentoPorSms: `${covid}/enviarTokenCancelamentoPorSms`,
    consultaAgendaCancelamento: `${covid}/consultaAgendaCancelamento`,
    cancelarAgenda: `${covid}/cancelarAgenda`
  }
}